module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Liverpool.png
// module id = 2085
// module chunks = 4